import AppLock from './AppLock'

export default class StoreActionLock extends AppLock {
}
